import React from "react";
import { Route, Redirect } from "react-router-dom";
import { getToken } from "./Common.jsx";

// handle the public routes
function PublicRoute({ component: Component, ...rest }) {
  const token = getToken();
  
  return (
    <Route
      {...rest}
      render={(props) =>
        !token ? (
          <Component {...props} />
        ) : (
          <Redirect to={{ pathname: "/dashboard" }} />
        )
      }
    />
  );
}

export default PublicRoute;
